import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IObjects, IPrograms, IStepOne, TError } from './types/step-one-interface';
import { fetchDefaultId, fetchDictionaries, fetchPrograms, fetchStepOne } from './action/fetch-step-one';

const initialState: IStepOne = {
    City: '',
    programId: '',
    InsuranceCount: 1,
    Promocode: '',
    Price: 0,
    Sum: 0,
    Uid: '',
    isLoadingCalc: false,
    errorCalc: [],
    Dictionaries: {
        Regions: [],
        Programs: [],
        isLoadingDictionaries: false,
        errorDictionaries: [],
    },
    Programs: {
        Programs: [],
        isLoadingPrograms: false,
        errorPrograms: [],
    },
    DefaultId: {
        DefaultId: '',
        isLoadingDefaultId: false,
        errorDefaultId: [],
    }
};

export const StepOneSlice = createSlice({
    name: 'StepOneSlice',
    initialState,
    reducers: {
        updateField: (state, action: PayloadAction<{ field: keyof IStepOne; value: IStepOne[keyof IStepOne] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
        resetForm: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStepOne.pending, (state) => {
                state.isLoadingCalc = true;
            })
            .addCase(fetchStepOne.fulfilled, (state, action: PayloadAction<{ price: number, uid: string, sum: number }>) => {
                state.Price = action.payload.price;
                state.Uid = action.payload.uid;
                state.Sum = action.payload.sum;
                state.isLoadingCalc = false;
                state.errorCalc = [];
            })
            .addCase(fetchStepOne.rejected, (state, action) => {
                state.Price = initialState.Price;
                state.Uid = initialState.Uid;
                state.isLoadingCalc = false;
                state.errorCalc = action.payload as TError;
            })
            .addCase(fetchDictionaries.pending, (state) => {
                state.Dictionaries.isLoadingDictionaries = true;
            })
            .addCase(fetchDictionaries.fulfilled, (state, action: PayloadAction<{ Regions: IObjects[], Programs: IPrograms[] }>) => {
                state.Dictionaries.Regions = action.payload.Regions;
                state.Dictionaries.Programs = action.payload.Programs;
                state.Dictionaries.isLoadingDictionaries = false;
                state.Dictionaries.errorDictionaries = [];
            })
            .addCase(fetchDictionaries.rejected, (state, action) => {
                state.Dictionaries.Regions = initialState.Dictionaries.Regions;
                state.Dictionaries.Programs = initialState.Dictionaries.Programs;
                state.Dictionaries.isLoadingDictionaries = false;
                state.Dictionaries.errorDictionaries = action.payload as TError;
            })
            .addCase(fetchPrograms.pending, (state) => {
                state.Programs.isLoadingPrograms = true;
            })
            .addCase(fetchPrograms.fulfilled, (state, action: PayloadAction<{ Programs: IPrograms[] }>) => {
                state.Programs.Programs = action.payload.Programs;
                state.Programs.isLoadingPrograms = false;
                state.Programs.errorPrograms = [];
            })
            .addCase(fetchPrograms.rejected, (state, action) => {
                state.Programs.Programs = initialState.Dictionaries.Programs;
                state.Programs.isLoadingPrograms = false;
                state.Programs.errorPrograms = action.payload as string[];
            })

            .addCase(fetchDefaultId.pending, (state) => {
                state.DefaultId.isLoadingDefaultId = true;
            })
            .addCase(fetchDefaultId.fulfilled, (state, action: PayloadAction<{ DefaultId: string }>) => {
                state.DefaultId.DefaultId = action.payload.DefaultId;
                state.DefaultId.isLoadingDefaultId = false;
                state.DefaultId.errorDefaultId = [];
            })
            .addCase(fetchDefaultId.rejected, (state, action) => {
                state.DefaultId.DefaultId = initialState.DefaultId.DefaultId;
                state.DefaultId.isLoadingDefaultId = false;
                state.DefaultId.errorDefaultId = action.payload as TError;
            })
    },
});

export const { updateField } = StepOneSlice.actions;
export default StepOneSlice.reducer;
